import { fetchAll } from './fetch';
import ServiceCategory from 'models/serviceCategory';

export default fetchAll('serviceCategory', ServiceCategory, null);
